import { lazy } from 'react';

export const RewardRetryForm = lazy(() => import('./RewardRetryForm'));
